<template>
  <div>
    <vue-table
      :data="tableData"
      :headers="headers"
      :loading="loading"
      @change="onPagination"
      :item-class="getRowClass"
      item-key="variant_id" 
    >
      <template v-slot:filters="{ props, perPage }">
        <v-row no-gutters class="mb-4">
          <v-col class="pa-2" cols="12" lg="2" md="3">
            <v-select v-model="props.length" :items="perPage" class="rounded-lg" dense hide-details label="تعداد در هر صفحه" outlined @change="() => onPagination(props)"/>
          </v-col>      
          <v-col class="pa-2" cols="12" lg="2" md="3">
            <v-select v-model="props.column" :items="columnOptions" label="مرتب‌سازی براساس" dense hide-details outlined class="rounded-lg" @change="() => onPagination(props)"/>
          </v-col>
          <v-col class="pa-2" cols="12" lg="2" md="3">
            <v-select v-model="props.dir" :items="dirOptions" label="جهت مرتب‌سازی" dense hide-details outlined class="rounded-lg" @change="() => onPagination(props)"/>
          </v-col>
            <v-col class="pa-2" cols="12" lg="2" md="3">
            <v-select v-model="props.is_linked" :items="isLinkOptions"  label="وضعیت اتصال"  dense hide-details outlined clearable class="rounded-lg" @change="() => onPagination(props)" />
            </v-col>

          <v-col class="pa-2" cols="12" lg="3" md="3">
            <v-text-field v-model="props.search" append-icon="mdi-magnify" label="جستجو در عنوان..." outlined dense hide-details clearable class="rounded-lg" @keyup.enter="() => onPagination(props)" @click:clear="() => { props.search = null; onPagination(props); }"/>
          </v-col>
          <v-col class="pa-2" cols="12" lg="3" md="3">
            <v-select v-model="props.flag" :items="flagOptions" label="فیلتر وضعیت" outlined prepend-inner-icon="mdi-filter-variant" dense hide-details clearable class="rounded-lg" @change="() => onPagination(props)"/>
          </v-col>
        </v-row>
      </template>

      <template v-slot:index="{item}">
        {{ persian(item.index + 1 + (tableData.current_page - 1) * tableData.per_page) }}
      </template>

      <template v-slot:image_src="{ item }">
        <div class="d-flex flex-column align-center pa-2">
          <v-img :src="item.image_src" max-width="115" max-height="115" contain />
        </div>
      </template>

      <template v-slot:kala="{ item }">
        <div class="d-flex flex-column align-start text-right py-2">
          <div class="d-flex align-center gap-2 mb-1 flex-wrap">
            <v-chip x-small label :color="item.is_linked ? 'success' : 'error'" text-color="white" class="font-weight-bold px-2">
              <v-icon x-small left>{{ item.is_linked ? 'mdi-link-variant' : 'mdi-link-variant-off' }}</v-icon>
              {{ item.is_linked ? 'متصل' : 'عدم اتصال' }}
            </v-chip>
            <span class="product-title font-weight-bold">
              <template v-if="item.title && item.title.includes(':')">
                <span>{{ item.title.split(':')[0] }} :</span>
                <span class="primary--text mr-1">{{ item.title.split(':').slice(1).join(':') }}</span>
              </template>
              <template v-else>
                {{ item.title }}
              </template>
            </span>
          </div>                 
          <div class="d-flex align-center gap-2 grey--text text--darken-1 text-caption">
            <a :href="`https://www.digikala.com/product/dkp-${item.product_id}`" target="_blank" class="dkp-link">DKP-{{ item.product_id }}</a>
            <span class="mx-1">|</span>
            <span>{{ item.product_id }}</span>
            <span class="mx-1">|</span>
            <span class="variant-code">DKPC-{{ item.variant_id }}</span>
          </div>
        </div>
      </template>

      <template v-slot:variant_id="{item}">
        <v-chip class="px-2 py-3 rounded-lg" color="transparent">
          <span class="text-body-2 font-weight-bold">{{ persian(item.variant_id) }}</span>
          <v-btn icon small @click.stop="copyID(item.variant_id)" class="ms-2" color="#B5C5FD">
            <v-icon small>mdi-content-copy</v-icon>
          </v-btn>
        </v-chip>
      </template>

      <template v-slot:updated_at="{ item }">
        <v-icon small class="ml-1">mdi-clock-outline</v-icon>
        {{ item.updated_at==null?'به روزرسانی نشده' : jalalian(item.updated_at,"datetime") }}
      </template>

      <template v-slot:smart_updated_at="{ item }">
        <v-icon small class="ml-1">mdi-clock-outline</v-icon>
        {{ item.smart_updated_at==null?'قیمت گذاری نشده': jalalian(item.smart_updated_at,"datetime") }}
      </template>                          

      <template v-slot:flag="{ item }">
        <v-chip :color="getFlagColor(item.flag)" text-color="white" small class="pa-2">
          {{ getFlagText(item.flag) }}
        </v-chip>
      </template>

      <template v-slot:action="{ item }">
        <div @click.stop.prevent @mousedown.stop.prevent>
          <v-btn
            :icon="$vuetify.breakpoint.mdAndUp"
            :class="[
              'btn-show rounded-pill',
              $vuetify.breakpoint.mdAndUp ? 'pa-0' : 'px-3 py-1 text-caption'
            ]"
            title="اتصال به دیجی‌کالا"
            @click="$emit('link', item)"
          >
            <v-icon small :left="$vuetify.breakpoint.smAndDown">
              mdi-link-variant-plus
            </v-icon>                    
            <span class="d-md-none">اتصال به دیجی‌کالا</span>
          </v-btn>

          <action-buttons :data="item" :meta="metabutton"/>
        </div>
      </template>
    </vue-table>
  </div>
</template>

<script>
import ActionButtons from "@/view/components/adapters/qrList/ordersListButton.vue";

export default {
  name: "ArchiveVariants",
  components: { 
    ActionButtons
  },
  data: () => ({
    loading: false,
    tableProps: {
      page: 1,
      length: 10,
      search: null,
      flag: null,
      dir: 'desc',
      column: 'updated_at',
      status: null, 
      is_linked: null,
      is_archived: true
    },
    tableData: {
      data: [],
      total: 0,
      current_page: 1,
      per_page: 10
    },
    isLinkOptions: [
      { text: 'همه موارد', value: null },
      { text: 'متصل شده', value: 1 },
      { text: 'متصل نشده', value: 0 },
    ],
    flagOptions: [
      { text: 'همه موارد', value: null },
      { text: 'سبز (بدون رقیب/سقف)', value: 'green' },
      { text: 'زرد (رقیب بالاتر/سقف)', value: 'yellow' },
      { text: 'قرمز (رقابت در بازه مجاز)', value: 'red' },
      { text: 'نارنجی (رقیب ارزان‌تر از کف)', value: 'orange' }
    ],
    columnOptions: [
      { text: "تاریخ بروزرسانی", value: "updated_at" },
      { text: "شناسه تنوع", value: "variant_id" },
      { text: "تاریخ بروزرسانی قیمت", value: "smart_updated_at" },
    ],
    dirOptions: [
      { text: "نزولی", value: "desc" },
      { text: "صعودی", value: "asc" }
    ],
    headers: [
      { value: 'index', text: 'ردیف', sortable: false, align: 'center' },
      { value: 'variant_id', text: 'شناسه تنوع', sortable: false, align: 'center' },
      { value: 'image_src', text: 'تصویر محصول', sortable: false, align: 'center' },
      { value: 'kala', text: 'عنوان و کد محصول', sortable: false, align: 'center' },
      { value: 'flag', text: 'وضعیت', sortable: false, align: 'center' },
      { value: 'updated_at', text: 'آخرین به‌روزرسانی', sortable: false, align: 'center' },
      { value: 'smart_updated_at', text: 'آخرین به روزرسانی قیمت',sortable: false, align: 'center'},
      { text: "عملیات", value: "action", sortable: false, align: "center"}
    ],
  }),
  computed: {
    metabutton() {
      return {
        buttons: [
           {
          name: "translateShowDigi",
          label: "نمایش در دیجی‌کالا",
          icon: "open-in-new", // تغییر از eye به open-in-new
          class: "btn-show rounded-pill",
          action: (row) => this.openDigiShow(row),
        },
        {
          name: "translateManagementDigi",
          label: "مدیریت در دیجی‌کالا",
          icon: "store-edit-outline",
          class: "btn-buy rounded-pill",
          action: (row) => this.openDigiManag(row),
        },
          // { name: "edit", label: "ویرایش قیمت‌گذاری", icon: "cash-sync", class: "btn-download rounded-pill", action: this.actionsTe },
          // { name: "multi_pricing", label: "قیمت‌گذاری چند حالته", icon: "layers-triple-outline", class: "btn-get-code rounded-pill ml-2", action: this.actionsTe },
        ],
      };
    }
  },
  mounted() {
    this.fetch();
  },
  methods: {
       
            openDigiManag(item) {
        const variantId = item.variant_id;
        const url = `https://seller.digikala.com/pwa/variant-management?filterSearchIn=search_term&filterSearchQuery=${variantId}&page=1`;
        
        window.open(url, '_blank');
      },
    openDigiShow(item) {
        const dkp = item.product_id;
        const url = `https://www.digikala.com/product/dkp-${dkp}/`;
        
        window.open(url, '_blank');
      },
    actionsTe(data, type) {
      this.$emit(type, data);
    },
    async fetch() {
      this.loading = true;
      try {
        const res = await this.$api.get('/v1/digikala/variant-list', { params: this.tableProps });
        this.tableData = res.data.data || res.data; 
      } catch (error) {
        this.$toast?.error("خطا در دریافت لیست بایگانی");
      } finally {
        this.loading = false;
      }
    },
    onPagination(e) {
      if (e && typeof e === 'object' && !Array.isArray(e)) {
        if (
          ('search' in e && e.search !== this.tableProps.search) || 
          ('flag' in e && e.flag !== this.tableProps.flag) ||
          ('is_linked' in e && e.is_linked !== this.tableProps.is_linked)
        ) {
          e.page = 1;
        }
        this.tableProps = { ...this.tableProps, ...e };
      }
      this.fetch();
    },
    copyID(textToCopy) {
      const text = String(textToCopy); 
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => {
          this.$toast?.success("با موفقیت کپی شد");
        }).catch(() => {
          this.$toast?.error("خطا در کپی");
        });
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        this.$toast?.success("با موفقیت کپی شد");
      }
    },
    getRowClass(item) {
      let classes = [];    
      if (item.flag) {
        const flagMap = { green: 'row-bg-green', yellow: 'row-bg-yellow', red: 'row-bg-red', orange: 'row-bg-orange' };
        if (flagMap[item.flag]) classes.push(flagMap[item.flag]);
      }    
      classes.push(item.is_linked ? 'row-linked' : 'row-unlinked');
      return classes.join(' ');
    },
    getFlagText(flag) {
      const map = { green: "رقیب ندارد (قیمت سقف)", yellow: "قیمت رقیب بالا (قیمت سقف)", red: "کسری قیمت (رقابت)", orange: "رقیب ارزان‌تر از کف (قیمت کف)" };
      return map[flag] || flag || "بررسی نشده";
    },
    getFlagColor(flag) {
      const map = { green: "success", yellow: "warning", red: "error", orange: "orange" };
      return map[flag] || "grey";
    }
  }
};
</script>

<style scoped>
.gap-2 { gap: 8px; }
.product-title { font-size: 0.9rem; color: #424242; line-height: 1.6; }
.dkp-link { text-decoration: none; color: #1976d2; font-weight: 500; border-bottom: 1px dashed #1976d2; }
.variant-code { background: #f0f0f0; padding: 2px 6px; border-radius: 4px; font-family: monospace; }
::v-deep .row-bg-green { background-color: #e8f5e9 !important; }
::v-deep .row-bg-yellow { background-color: #fffde7 !important; }
::v-deep .row-bg-red { background-color: #ffebee !important; }
::v-deep .row-bg-orange { background-color: #fff3e0 !important; }
::v-deep .row-bg-green:hover { background-color: #c8e6c9 !important; }
::v-deep .row-bg-yellow:hover { background-color: #fff9c4 !important; }
::v-deep .row-bg-red:hover { background-color: #ffcdd2 !important; }
::v-deep .row-bg-orange:hover { background-color: #ffe0b2 !important; }
::v-deep .row-linked { border-right: 4px solid #4caf50 !important;}
::v-deep .row-unlinked { border-right: 4px solid #f44336 !important; opacity: 0.88; }
</style>
